import { createElement, PropsWithChildren, ReactNode } from 'react';
import {
  CloseCircle,
  colors,
  Drawer,
  MediaMatch,
  Modal,
  useViewport,
} from '@lamimed/pantheon';
import { LucideIcon } from 'lucide-react';

import { Divider } from 'components/Divider';

import * as S from './styles';

interface Props extends PropsWithChildren {
  open: boolean;
  onClose: () => void;
  title: string;
  icon: LucideIcon;
  footer?: ReactNode;
}

export function AlertBox({
  open,
  onClose,
  title,
  icon,
  footer,
  children,
}: Props) {
  const { lessThan } = useViewport();

  const titleComponent = (
    <S.Title variant="heading_5" marginBottom="none">
      {title}
    </S.Title>
  );

  const drawerHeader = (
    <S.Row full>
      {createElement(icon, {
        size: 18,
        color: colors.dark,
      })}

      {titleComponent}
    </S.Row>
  );

  return (
    <S.Alert
      as={lessThan('tablet') ? Drawer : Modal}
      open={open}
      onClose={onClose}
      dismissible
      title={drawerHeader}
      closeButtonColor="dark"
      closeIconSize={18}
      size="small"
      showCloseButton={false}
    >
      <S.Container>
        <MediaMatch greaterThan="tablet">
          <S.Header>
            <S.Row>
              {createElement(icon, {
                size: 18,
                color: colors.dark,
              })}

              {titleComponent}
            </S.Row>

            <S.CloseButton
              onClick={onClose}
              aria-label="chiudi la finestra di dialogo"
            >
              <CloseCircle width={18} height={18} color="dark" />
            </S.CloseButton>
          </S.Header>
        </MediaMatch>

        {children}

        {footer && (
          <div>
            <Divider marginBottom="medium" marginTop="medium" />

            {footer}
          </div>
        )}
      </S.Container>
    </S.Alert>
  );
}

function Footer({ children }: PropsWithChildren) {
  return <S.Footer>{children}</S.Footer>;
}

AlertBox.Footer = Footer;
